import { Box, Flex } from '@chakra-ui/react';
import { CheckMark } from '../iconComponents/CheckMark';

interface CheckBoxProps {
    index: number;
    isChecked: boolean;
    onValueChange: (newIndex: number) => void;
}

export const CustomCheckBox: React.FC<CheckBoxProps> = ({ index, isChecked, onValueChange }) => {
    return (
        <Box
            className={'wrapper-checkbox'}
            onClick={() => {
                onValueChange(index);
            }}
        >
            <Flex
                className={
                    isChecked
                        ? 'wrapper-checkbox-background checkbox-on'
                        : 'wrapper-checkbox-background'
                }
            >
                {isChecked && <CheckMark />}
            </Flex>
        </Box>
    );
};
